/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGears = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M19.121 5.221a3.012 3.012 0 0 0-.474-.386l.323-1.292-1.94-.486-.325 1.3c-.333.033-.66.121-.97.264l-1.028-1.028-1.414 1.414 1.013 1.014a3 3 0 0 0-.288.994l-1.26.315.484 1.94 1.232-.308a3.012 3.012 0 0 0 .86.877l-.304 1.218 1.94.486.303-1.213c.36-.032.717-.13 1.05-.293l.97.97 1.414-1.414-.986-.986a3 3 0 0 0 .27-1.024l1.251-.313-.485-1.94-1.28.32a3.013 3.013 0 0 0-.356-.429zm-3.03 3.031a1.286 1.286 0 1 1 1.818-1.818 1.286 1.286 0 0 1-1.818 1.818zM8 9.3v1.44a4.62 4.62 0 0 0-1.516.63l-1.02-1.02-1.414 1.414 1.02 1.02a4.64 4.64 0 0 0-.63 1.516H3v2h1.44c.12.548.336 1.06.63 1.516l-1.02 1.02 1.414 1.414 1.02-1.02A4.64 4.64 0 0 0 8 19.86v1.44h2v-1.44a4.641 4.641 0 0 0 1.517-.63l1.019 1.02 1.414-1.415-1.02-1.019a4.64 4.64 0 0 0 .63-1.516H15v-2h-1.44a4.641 4.641 0 0 0-.63-1.517l1.02-1.019-1.414-1.414-1.02 1.02A4.639 4.639 0 0 0 10 10.74V9.3H8zm1 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGears as Gears };
